import { z } from 'zod';
/**
 * Cursor pagination, mirroring `src/shared/http/pagination.ts`.
 *
 * There is deliberately no `total`. The API derives `hasMore` by fetching
 * `limit + 1` rows rather than issuing a COUNT, so a total is not available for
 * free and the console must render ranges ("showing 1–20") rather than
 * "1–20 of 248".
 */
export const paginationMetaSchema = z.object({
    nextCursor: z.string().nullable(),
    hasMore: z.boolean(),
    limit: z.number().int(),
});
export const DEFAULT_PAGE_LIMIT = 20;
export const MAX_PAGE_LIMIT = 100;
/**
 * Query parameters every admin list endpoint accepts. `coerce` because these
 * arrive as strings on the query string.
 */
export const cursorPageQuerySchema = z.object({
    cursor: z.string().optional(),
    limit: z.coerce.number().int().min(1).max(MAX_PAGE_LIMIT).default(DEFAULT_PAGE_LIMIT),
});
/** A success envelope whose `data` is an array and whose `meta` carries pagination. */
export function paginatedEnvelope(item) {
    return z.object({
        success: z.literal(true),
        data: z.array(item),
        meta: z.object({ pagination: paginationMetaSchema }).passthrough(),
    });
}
//# sourceMappingURL=pagination.js.map